// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vMKnIEFIjQgOwB5uDUow{--titled-row-action-width:320px;gap:20px;display:grid}.vMKnIEFIjQgOwB5uDUow ul{padding-left:20px;list-style-type:disc;display:grid}.hwtUpGxPlaw7qmELMb2q{grid-template-columns:1fr 108px;gap:20px;display:grid}.V9n6rmoP3ToJ06JJI8VG{padding-left:12px}.V9n6rmoP3ToJ06JJI8VG input{color:var(--content-primary-tertiary)}.knpF3t1ZgEsy3rctC1_f{background-color:var(--border-neutral-default);width:100%;height:1px;display:grid}.fuuquIzLVoRTLfcnE7zg{align-items:center;gap:10px;width:100%;display:flex}.V9UbIsP4WI4LtygTwYZu{margin-left:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vMKnIEFIjQgOwB5uDUow`,
	"urlForm": `hwtUpGxPlaw7qmELMb2q`,
	"input": `V9n6rmoP3ToJ06JJI8VG`,
	"divider": `knpF3t1ZgEsy3rctC1_f`,
	"row": `fuuquIzLVoRTLfcnE7zg`,
	"rowSwitch": `V9UbIsP4WI4LtygTwYZu`
};
export default ___CSS_LOADER_EXPORT___;
